import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { PublicRoute } from './components/PublicRoute';
import { ProtectedRoute } from './components/ProtectedRoute';

// Components
import Navbar from './components/layouts/Navbar';
import LocalizationWrapper from './components/LocalizationWrapper';
import MainLayout from './components/layouts/MainLayout';
import { AdminCheck } from './components/AdminCheck';
import LoadingScreen from './components/LoadingScreen';

// Global styles
import './styles/global.css';

// Pages
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const UserApproval = lazy(() => import('./pages/Admin/UserApproval'));
const Settings = lazy(() => import('./pages/Admin/Settings'));
const VolunteerManagement = lazy(() => import('./pages/Admin/VolunteerManagement'));
const FormManagement = lazy(() => import('./pages/Admin/FormManagement'));
const AdminDashboard = lazy(() => import('./pages/Admin/Dashboard'));
const EventManagement = lazy(() => import('./pages/Admin/EventManagement'));
const ShiftManagement = lazy(() => import('./pages/Admin/ShiftManagement'));
const Profile = lazy(() => import('./pages/Profile'));
const ActivityLogs = lazy(() => import('./pages/Admin/ActivityLogs'));
const VolunteerStatistics = lazy(() => import('./pages/Admin/VolunteerStatistics'));



function App() {
  return (
    <LocalizationWrapper>
      <Router>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AuthProvider>
            <AdminCheck />
            <Navbar />
            <MainLayout>
              <Suspense fallback={<LoadingScreen />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                <Route 
                  path="/login" 
                  element={
                    <PublicRoute>
                      <Login />
                    </PublicRoute>
                  } 
                />
                <Route 
                  path="/register" 
                  element={
                    <PublicRoute>
                      <Register />
                    </PublicRoute>
                  } 
                />
                <Route 
                  path="/dashboard" 
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/settings" 
                  element={
                    <ProtectedRoute adminOnly>
                      <Settings />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/volunteers" 
                  element={
                    <ProtectedRoute adminOnly>
                      <VolunteerManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/forms" 
                  element={
                    <ProtectedRoute adminOnly>
                      <FormManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/approve" 
                  element={
                    <ProtectedRoute adminOnly>
                      <UserApproval />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin" 
                  element={
                    <ProtectedRoute adminOnly>
                      <AdminDashboard />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/events" 
                  element={
                    <ProtectedRoute adminOnly>
                      <EventManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/shifts" 
                  element={
                    <ProtectedRoute adminOnly>
                      <ShiftManagement />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/logs" 
                  element={
                    <ProtectedRoute adminOnly>
                      <ActivityLogs />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/admin/statistics" 
                  element={
                    <ProtectedRoute adminOnly>
                      <VolunteerStatistics />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                </Routes>
              </Suspense>
            </MainLayout>
          </AuthProvider>
        </ThemeProvider>
      </Router>
    </LocalizationWrapper>
  );
}

export default App;